/* Cozyleigh ship dates, shared (Oct 25 2026). The same maths as the product page's status line
   (snippets/ready-to-ship-badge.liquid): business days counted in America/New_York, a lead time such as
   "within 1 week" or "1–2 weeks" read at its upper bound (a week is five business days).
   window.CozyleighShipDate = { leadDays(text), addDays(n), fmtDay(d) }
   leadDays("1–2 weeks") -> 10, leadDays("within 1 week") -> 5, leadDays("soon") -> null.
   addDays(n) -> a Date n business days from today; fmtDay(d) -> "Fri, Oct 30". */
(function () {
  if (window.CozyleighShipDate) return;
  function addDays(n) {
    var d;
    try { d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { d = new Date(); }
    d.setHours(12, 0, 0, 0);
    var left = n;
    while (left > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) left--; }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  }
  function fmtDay(d) {
    try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return fmt(d); }
  }
  // "within 1 week", "1–2 weeks", "5–7 business days", "3 days": the upper bound, in business days (a week is five).
  function leadDays(s) {
    if (!s) return null;
    var t = String(s);
    var m = t.match(/(\d+)\s*(?:[–—-]|to)\s*(\d+)\s*(?:business\s+|working\s+)?(day|week|wk|month)/i) || t.match(/(\d+)()\s*(?:business\s+|working\s+)?(day|week|wk|month)/i);
    if (!m) return null;
    var a = parseInt(m[1], 10), b = m[2] ? parseInt(m[2], 10) : a, u = m[3].toLowerCase();
    var mult = u.indexOf('day') === 0 ? 1 : (u.indexOf('month') === 0 ? 21 : 5);
    return Math.max(a, b) * mult;
  }
  window.CozyleighShipDate = { leadDays: leadDays, addDays: addDays, fmtDay: fmtDay };
})();
